/**
 * Whether a personal ID code is the asterisks the backend sends in its place while the firm obfuscates it. Any
 * all-asterisk value counts, as in the backend, where saving one keeps the stored code.
 */
export const isPersonalCodeMask = (code: string | null | undefined): boolean => !!code && /^\*+$/.test(code);
